import {
  ContentState,
  SelectionState,
  Modifier,
} from 'draft-js';

const removeBlock = (contentState, blockKey) => {
  const block = contentState.getBlockForKey(blockKey);

  const targetRange = new SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: block.getLength(),
  });

  const withoutBlock = Modifier.removeRange(contentState, targetRange, 'backward');

  const blockMap = contentState.getBlockMap();
  const newBlockMap = blockMap.delete(blockKey);
  const newBlocksArray = newBlockMap.size ? newBlockMap.toArray() : [];

  const resultingContentState = ContentState
    .createFromBlockArray(newBlocksArray)
    .set('selectionBefore', withoutBlock.getSelectionBefore())
    .set('selectionAfter', withoutBlock.getSelectionAfter());

  return resultingContentState;
};

export default removeBlock;
